module.exports = __webpack_public_path__ + "static/media/dstv-svg.c23fadef.svg";